import { BaseService } from "./BaseService";
const config = require("../../config.js");
import { CognitoUser } from "amazon-cognito-identity-js";

export class ReservationService extends BaseService {
  constructor(
    public cognitoUser: CognitoUser,
    public dispatch = (any: any) => {},
    public url = config.domusoApiService,
  ) {
    super(url, cognitoUser, dispatch);
  }

  async getServiceRequestCategories(reservationId: string) {
    const url = `v1/my/reservation/${reservationId}/service_request/categories`;
    return this.makeGetRequest(url, true);
  }

  async createServiceRequest(reservationId: string, serviceRequest: any) {
    const url = `v1/my/reservation/${reservationId}/service_request`;
    return this.makePostRequest(url, serviceRequest, true);
  }

  async getServiceRequests(reservationId: string) {
    const url = `v1/my/reservation/${reservationId}/service_request`;
    return this.makeGetRequest(url, true);
  }
}
